import React, { useMemo } from "react";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { ThemeProvider } from "@mui/material";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import { createAppTheme } from "../themes/theme";
import { useLocale } from "./index";

const ltrCache = createCache({ key: "mui" });
// stylis must match Emotion's 4.2.0 parser; newer prefixers use incompatible nodes.
const rtlCache = createCache({ key: "muirtl", stylisPlugins: [prefixer, rtlPlugin] });

export default function LocalizedThemeProvider({ mode, children }) {
  const locale = useLocale();
  const theme = useMemo(() => createAppTheme(mode, locale), [mode, locale]);
  return (
    <CacheProvider value={locale === "ar" ? rtlCache : ltrCache}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </CacheProvider>
  );
}
